import React from "react";
import banner from "./img/banner.png";
import "./css/Blog.css";

function Blog() {
  return (
    <>
      <div className="blog">
        <img src={banner} alt="banner" />
        <div className="blog-content">
          <p className="mainText">Show case your writing skills</p>
          <p className="mainDesc">
            Take a step towards to improve your writing skills with Code With
            Akky.
          </p>
          <button>Write A Blog Now</button>
        </div>
      </div>
    </>
  );
}

export default Blog;
